import { ChevronLeft, ChevronRight, SkipBack, SkipForward } from 'lucide-react';
import { IconButton } from './IconButton';

interface FrameNavigationButtonsProps {
  onStepBackward: () => void;
  onStepForward: () => void;
  onJumpBackward: () => void;
  onJumpForward: () => void;
}

export function FrameNavigationButtons({
  onStepBackward,
  onStepForward,
  onJumpBackward,
  onJumpForward,
}: FrameNavigationButtonsProps) {
  return (
    <>
      {/* <IconButton onClick={onJumpBackward} title="Jump 10 Frames Back">
        <SkipBack size={20} />
      </IconButton>
      <IconButton onClick={onStepBackward} title="Previous Frame">
        <ChevronLeft size={20} />
      </IconButton>
      <IconButton onClick={onStepForward} title="Next Frame">
        <ChevronRight size={20} />
      </IconButton>
      <IconButton onClick={onJumpForward} title="Jump 10 Frames Forward">
        <SkipForward size={20} />
      </IconButton> */}
    </>
  );
}